<template>
	<div class="page-about">
<!-- 		<section class="gmap">
			<iframe id="gmap_canvas" :src="map" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe>
		</section> -->
		<section class="contact">
			<div class="container">
				<div class="row justify-content-between align-items-center">
					<div class="col-md-6 spaced-sm">
                        <p class="lead">
                            Email us at
                        </p>
                        <p class="lead">
<!--                             Email:
 -->                            <a href="mailto:contact@aedil.no">contact@aedil.no</a>
<!--                             <br> P: +621 4827 2694 -->
                        </p>
<!--                         <p class="lead">
                            We are open from 9am — 5pm week days.
                        </p> -->
<!--                         <hr class="short">
                        <form @submit="checkForm" v-if="!success">
							<div class="row">
								<div class="col">
									<input :disabled="submiting" type="text" v-model="name" required="" class="form-control" placeholder="Your Name">
								</div>
								<div class="col">
									<input :disabled="submiting" type="email" v-model="email" required="" name="email" placeholder="E-mail Address" class="form-control">
								</div>
							</div>
							<div class="row">
								<div class="col">
									<textarea :disabled="submiting" required="" v-model="message" rows="4" name="Message" placeholder="Message" class="form-control"></textarea>
								</div>
							</div>
							<div v-if="errors" class="alert alert-danger" role="alert">
								Please fill all the requried fields.
							</div>

							<div v-if="failed" class="alert alert-danger" role="alert">
								There was an error while submiting the form. Please try again later.
							</div>
			
							<button type="submit" :disabled="submiting" class="btn btn-primary btn-main">{{ (submiting) ? 'Sending...' : 'Send Enquiry' }}</button>
                        </form>
                        <div v-if="success" class="alert alert-success" role="alert">
							Thank you for contacting us. We will get back to you shortly.
						</div> -->
					</div>
					<div class="col-md-5">
						<img src="@/assets/logo2.png" alt="Contact">
					</div>
				</div>
			</div>
		</section>
	</div>	
</template>

<script>

import ContactService from '@/services/ContactService';

export default {
	name: 'Contact',
	data() {
		return {
			address   : "Bergen, Norway",

			name      :	null,
			email     :	null,
			message   :	null,

			errors	  :	false,
			failed	  :	false,
			success	  : false,
			submiting : false
		}
	},
	computed: {
	/* 	map() {
			return "https://maps.google.com/maps?q=" + encodeURIComponent(this.address) + "&t=&z=15&ie=UTF8&iwloc=&output=embed";
		} */
	},
	methods: {
		checkForm(e) {
			e.preventDefault();
			if (this.name.trim() && this.email.trim() && this.message.trim()) {
				this.errors = false;
				this.submiting = true;

				let formData = {
					name: this.name,
					email: this.email,
					message: this.message
				};

				ContactService.submit(formData)
					.then(() => this.success = true, this.failed = false)
					.catch(() => this.failed = true, this.success = false)
					.finally(() => this.submiting = false);
			} else {
				this.errors = true;
			}
		}
	}
}
</script>
